import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../../store';
import type { NewsItem, NewsState, SourceItem } from './types';
import { tenantScopeReset } from '../../Organizations/OrganizationsSlice/tenantScopeReset';

const initialState: NewsState = {
  news: [],
  listNews: [],
  listSource: [],
  isLoading: false,
  isListLodaing: false,
  error: null,
};

const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    setNews: (state, action: PayloadAction<NewsItem[]>) => {
      state.news = action.payload;
    },
    setListSource: (state, action: PayloadAction<SourceItem[]>) => {
      state.listSource = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(tenantScopeReset, () => initialState);
  },
});

export const { setNews, setListSource, setIsLoading, setIsError } = newsSlice.actions;

export default newsSlice.reducer;

export const selectNews = (state: RootState) => state.news.news;
export const selectNewsListSource = (state: RootState) => state.news.listSource;
export const selectNewsIsLoading = (state: RootState) => state.news.isLoading;
